import axios from 'axios';
import { BASE_URI_DEVELOPMENT_CENTER } from '@/api/CONST.js';

export const getGroup = ({ courseId, groupId, config }) => axios.get(`${BASE_URI_DEVELOPMENT_CENTER}/courses/${courseId}/groups/${groupId}`, {
    ...config,
});
